// extracted by mini-css-extract-plugin
module.exports = {"Title":"statuses_Title__X5_g2","CancelReasonLabel":"statuses_CancelReasonLabel__EKCgd","CancelReason":"statuses_CancelReason__dD4M2"};